import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {DomainGuard} from "../guards/domain.guard";

const routes: Routes = [
    {
        path: '',
        redirectTo: '/cadastro',
        pathMatch: 'full'
    },
    {
        path: ':segment',
        loadChildren: () => import('./cadastro/cadastro.module').then(m => m.CadastroPageModule),
        canActivate: [DomainGuard]
    },
    {
        path: '',
        loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
